// src/pages/HomePage.js
import React, { useEffect } from 'react'; // <<< CORRECTED: Merged into one line
import { useLocation } from 'react-router-dom';
import { scroller } from 'react-scroll';
import Header from '../components/Header';
import Hero from '../components/Hero';
import CraftingExcellence from '../components/CraftingExcellence';
import Services from '../components/Services';
import HowItWorks from '../components/HowItWorks';
import Projects from '../components/Projects';
import WhyChooseUs from '../components/WhyChooseUs';
import ContactForm from '../components/ContactForm';
import Team from '../components/Team';
import Testimonials from '../components/Testimonials';
import FAQs from '../components/FAQs';
import Footer from '../components/Footer';

export default function HomePage() {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollTo) {
      setTimeout(() => {
        scroller.scrollTo(location.state.scrollTo, {
          duration: 500,
          smooth: true,
          offset: -70,
        });
      }, 100);
    }
  }, [location]);

  return (
    <>
      <Header />
      <Hero />
      <CraftingExcellence />
      <Services />
      <HowItWorks />
      <Projects />
      <WhyChooseUs />
      <ContactForm />
      <Team />
      <Testimonials />
      <FAQs />
      <Footer />
    </>
  );
}